import React, { useEffect, Fragment } from "react";
import { useAppContext } from "../../../libs/contextLib";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { AppraisalService } from "../../../services/appraisal";
// import SearchUser from "../../helperComponents/searchUser";
import SearchUserAdvanced from "../../helperComponents/searchUserAdvanced";

import Grid from "@material-ui/core/Grid";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";

import moment from "moment";
import ErrorLoadingPage from "../../errorPages/errorLoadingPage";
import AppraisalDialog from "./appraisalDialog";
import AppraisalDialogHoS from "./appraisalDialogHoS";
import AlertDialog from "../../helperComponents/alertDialog";
import Toast from "../../helperComponents/toast";

import { Factory } from "../../../helpers/factories";

import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import GetAppIcon from "@material-ui/icons/GetApp";
// import generatePDF from "./generatePDF";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  dataGridRoot: {
    height: "100vh",
    width: "100%",
  },
  dataGrid: {
    backgroundColor: "white",
  },
}));

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

function Appraisals(props) {
  const classes = useStyles();
  const { currentUser } = useAppContext();

  //search user
  const [searchedUser, setSearchedUser] = React.useState(Factory.createUser);

  //query string
  const [queryString, setQueryString] = React.useState({});

  const [userQueryOptions, setUserQueryOptions] = React.useState({});

  //active appraisal
  const [activeAppraisal, setActiveAppraisal] = React.useState(
    Factory.createAppraisal
  );

  //loaded appraisals
  const [appraisals, setAppraisals] = React.useState([]);

  //current row selected
  const [selectedRowIndex, setSelectedRowIndex] = React.useState("");

  //operation type Save or Edit
  const [opType, setOpType] = React.useState("");

  //data is loading
  const [isDataLoading, setIsDataLoading] = React.useState(true);
  const [errorLoadingPage, setErrorLoadingPage] = React.useState(false);

  //appraisal dialog
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [isDialogOpenHoS, setIsDialogOpenHoS] = React.useState(false);

  //toast options
  const [toastOptions, setToastOptions] = React.useState({
    open: false,
    message: "",
    duration: 6000,
  });

  //alert dialog
  const [alertDialogOptions, setAlertDialogOptions] = React.useState({
    open: false,
    title: "",
    message: "Delete this appraisal?",
    cancelMessage: "Cancel",
    confirmMessage: "OK",
  });

  //rows for datagrid

  let rows = [];

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "_id", headerName: "_id", width: 120, hide: "true" },
    {
      field: "organisation",
      headerName: "Organisation",
      width: 120,
      hide: "true",
    },
    {
      field: "user",
      headerName: "Appraisal For",
      width: 200,
      renderCell: (params) => {
        return params.row.user.firstName + " " + params.row.user.lastName;
      },
    },
    {
      field: "createdBy",
      headerName: "Written By",
      width: 200,
      renderCell: (params) => {
        return (
          params.row.createdBy.firstName + " " + params.row.createdBy.lastName
        );
      },
    },

    {
      field: "type",
      headerName: "Type",
      width: 200,
      renderCell: (params) => {
        if (params.row.type === "area" || params.row.type === "domain") {
          return params.row.domainArea.displayName;
          // return "ok";
        } else {
          return params.row.type[0].toUpperCase() + params.row.type.substr(1);
        }
      },
    },
    { field: "learningCycle", headerName: "Cycle", width: 100 },
    { field: "year", headerName: "Year", width: 75 },

    {
      field: "dateCreated",
      headerName: "Date Created",
      width: 130,
      renderCell: (params) => {
        return moment(params.row.dateCreated).format("DD-MM-yyyy");
      },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 100,
    //   renderCell: (params) => {
    //     return params.row.status === "unlocked" ? (
    //       <LockOpenIcon color="primary" />
    //     ) : (
    //       <LockIcon color="primary" />
    //     );
    //   },
    // },
    {
      field: "",
      headerName: "",
      disableClickEventBubbling: true,
      width: 150,
      renderCell: (params) => {
        const onClick = async (op) => {
          let temp = { ...params.row };
          //set active appraisal
          setActiveAppraisal(temp);
          setSelectedRowIndex(params.row.id);
          switch (op) {
            case "edit":
              handleOpenDialog();
              break;
            case "view":
              if (
                currentUser.role === "headOfSchool" ||
                currentUser.role === "director"
              ) {
                handleOpenDialogHoS();
              } else {
                handleOpenDialog();
              }

              break;
            case "delete":
              handleConfirmDeleteAppraisal();
              break;

            default:
          }
        };

        return (
          <div>
            {currentUser.role === "headOfSchool" ||
            currentUser.role === "director" ||
            currentUser.id != params.row.createdBy._id ? (
              <Tooltip title="View">
                <IconButton
                  aria-label="view"
                  onClick={() => {
                    return onClick("view");
                  }}
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
              </Tooltip>
            ) : null}

            {currentUser.id === params.row.createdBy._id ? (
              <Fragment>
                <Tooltip title="Edit">
                  <IconButton
                    aria-label="edit"
                    onClick={() => {
                      return onClick("edit");
                    }}
                  >
                    <EditIcon color="primary" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    onClick={() => {
                      return onClick("delete");
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Fragment>
            ) : null}
          </div>
        );
      },
    },
  ];

  //pre-load verify token
  useEffect(() => {
    if (props.startFetchData) {
      onLoad();
    }
  }, [props.startFetchData, queryString]);

  //searched user
  useEffect(() => {
    if (searchedUser._id != "") {
      setQueryString({ ...queryString, user: searchedUser._id });
    } else {
      setQueryString({});
    }
  }, [searchedUser]);

  //get appraisals
  async function onLoad() {
    try {
      setAppraisals(
        await AppraisalService.getAppraisalsByOrgId(
          currentUser.organisation.id,
          queryString
        )
      );
      setIsDataLoading(false);
    } catch (err) {
      setErrorLoadingPage(true);
    }
  }

  function loadRows() {
    let temp = [];
    appraisals.forEach((appraisal, index, anns) => {
      appraisal["id"] = index;
      temp.push(appraisal);
    });
    return temp;
  }

  function handleCreateAppraisal() {
    setActiveAppraisal(Factory.createAppraisal);
    setOpType("add");
    setIsDialogOpen(true);
  }

  const handleCloseDialog = () => {
    setActiveAppraisal(Factory.createAppraisal);
    setIsDialogOpen(false);
  };

  const handleCloseDialogHoS = () => {
    setIsDialogOpenHoS(false);
  };

  const handleOpenDialog = () => {
    setOpType("edit");
    setIsDialogOpen(true);
  };

  const handleOpenDialogHoS = () => {
    setIsDialogOpenHoS(true);
  };

  function handleOpenAlertDialog() {
    setAlertDialogOptions({ ...alertDialogOptions, open: true });
  }

  function handleCloseAlertDialog() {
    setAlertDialogOptions({ ...alertDialogOptions, open: false });
  }

  function handleConfirmDeleteAppraisal() {
    handleOpenAlertDialog();
  }

  async function handleProceedDeleteAppraisal() {
    setAlertDialogOptions({ ...alertDialogOptions, open: false });
    let temp = [...appraisals];
    temp.splice(selectedRowIndex, 1);
    try {
      await AppraisalService.deleteAppraisalsByOrgIdAndAppraisalId(
        currentUser.organisation.id,
        activeAppraisal._id
      );
      setAppraisals(temp);
      setToastOptions({
        ...toastOptions,
        open: true,
        message: "Appraisal Deleted",
      });
    } catch (err) {
      setToastOptions({
        ...toastOptions,
        open: true,
        message: "Error deleting appraisal. It may be locked.",
      });
    }
  }

  //toast
  const handleCloseToast = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastOptions({ ...toastOptions, open: false });
  };

  //data grid
  function AppraisalDataGrid(props) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.dataGridRoot}>
          <DataGrid
            className={classes.dataGrid}
            rows={rows}
            columns={columns}
            pageSize={10}
            autoHeight={true}
            loading={isDataLoading}
            checkboxSelection={false}
            {...props}
          />
        </Grid>
      </Grid>
    );
  }

  //appraisal
  function appraisalComponent(props) {
    return (
      <Fragment>
        <Toast
          toastOptions={toastOptions}
          handleCloseToast={handleCloseToast}
        />
        <AlertDialog
          alertDialogOptions={alertDialogOptions}
          handleClose={handleCloseAlertDialog}
          handleConfirm={handleProceedDeleteAppraisal}
        />
        {/* View/Edit Appraisal Dialog */}

        <AppraisalDialog
          activeAppraisal={activeAppraisal}
          setActiveAppraisal={setActiveAppraisal}
          appraisals={appraisals}
          setAppraisals={setAppraisals}
          isDialogOpen={isDialogOpen}
          handleCloseDialog={handleCloseDialog}
          selectedRowIndex={selectedRowIndex}
          setSelectedRowIndex={setSelectedRowIndex}
          opType={opType}
          setOpType={setOpType}
          toastOptions={toastOptions}
          setToastOptions={setToastOptions}
        />
        {/* View/Edit Appraisal Dialog for Director and HoS*/}

        <AppraisalDialogHoS
          activeAppraisal={activeAppraisal}
          setActiveAppraisal={setActiveAppraisal}
          isDialogOpenHoS={isDialogOpenHoS}
          handleCloseDialogHoS={handleCloseDialogHoS}
          opType={opType}
          setOpType={setOpType}
          toastOptions={toastOptions}
          setToastOptions={setToastOptions}
        />
        {/* </Dialog> */}
        {/* Appraisal Form */}
        <div className={classes.root}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12}>
              <Typography variant="h4" className={classes.textCenter}>
                Reports
              </Typography>
            </Grid> */}
            <Grid
              item
              xs={12}
              sm={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleCreateAppraisal}
              >
                Add Appraisal
              </Button>
            </Grid>
            <Grid container spacing={3}>
              {/* <Grid item xs={12}>
              <Typography variant="h4" className={classes.textCenter}>
                Reports
              </Typography>
            </Grid> */}
              <Grid item xs={12} sm={12}>
                <SearchUserAdvanced
                  user={searchedUser}
                  setUser={setSearchedUser}
                  userQueryOptions={userQueryOptions}
                  setUserQueryOptions={setUserQueryOptions}
                  style={{ display: "flex" }}
                />
                {/* <SearchUser
                  user={searchedUser}
                  setUser={setSearchedUser}
                  role={""}
                  style={{ display: "flex" }}
                /> */}
              </Grid>
            </Grid>
            {AppraisalDataGrid()}
          </Grid>
        </div>
      </Fragment>
    );
  }

  if (!errorLoadingPage) {
    rows = loadRows();
    return appraisalComponent();
  } else {
    return <ErrorLoadingPage />;
  }
}

export default Appraisals;
